import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Cce } from '../../../models/Cce';

@Component({
  selector: 'app-cce-selector',
  templateUrl: './cce-selector.component.html',
  styleUrls: ['./cce-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CceSelectorComponent),
      multi: true
    }
  ]
})
export class CceSelectorComponent implements OnInit {
  public selectedCce: Cce;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  onCceChange(e) {
    console.log(e)
    this.propagateChange(this.toModel());
  }

  toModel() {
    return this.selectedCce ? {
      codice: this.selectedCce.codice,
      descrizione: this.selectedCce.descrizione,
    } : {}
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Cce) {
    console.log('CceSelectorComponent - writeValue', obj)
    if (obj)
      this.selectedCce = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/cce-selector/cce-selector.component.ts